import React from 'react'
import moment from 'moment-timezone'
import numeral from 'numeral'
import _ from 'underscore'

import 'kendo'
import 'webui-popover'
import 'webui-popover-css'

import {AgGridReact} from 'ag-grid-react'
import agGrid from 'ag-grid'
import 'ag-grid-root/dist/styles/ag-grid.css'
import './styles/ag-grid.css'
import './styles/trading_widgets.css'

import 'd3'
import 'metrics-graphics'
import './styles/chart.css'

function formatNumeric(value, format) {
	if (value === undefined)
			return '';
	if (isNaN(value))
			return '';
	if (format === undefined) {
			format = '0,0'
	}
	return numeral(value).format(format)
}
const GRID_COLUMNS = [
	{headerName: "Group", field: "_group", cellRenderer: 'agGroupCellRenderer',width: 100, suppressToolPanel: true},
	// {headerName: '#',field: "position_key",width: 70,suppressMenu: true,suppressResize: true, cellClass: 'cellPrice'},
  	{headerName: 'Book',field: "book_name",width: 150,
              //  comparator: agGrid.defaultGroupComparator,
							//  cellRenderer: 'group',
              //  rowGroupIndex: 0
	},
  	{headerName: 'Tag',field: "tag",width: 80,
							//  rowGroupIndex: 1
	},
	{headerName: 'Instrument',field: "symbol",width: 120, cellClass: 'multiline',
							 cellRenderer: (dataContext) => {
                  if (dataContext.node.group) return dataContext.value || ''
									var html = '';
									html += "<span class=''>" + (dataContext.data['pricefeed_description'] || dataContext.data["instrument_description"] || dataContext.value) + "</span>";
									html += "<br/><span class='footnote'>" + dataContext.value + "</span>";
									return html;
							 }
	},
  	{headerName: 'Product Type',field: "product_type",width: 100,},
	{headerName: 'Position',field: "current_quantity",width: 100, cellClass:"cellRight",
    	cellClass: (d) => { return (d.value > 0 ? "positive cellRight" : (d.value < 0 ? "negative cellRight" : "cellRight")) + (d.node.group ? '' : ' hasDrillDown') },
      	cellRenderer:(d) => {
			return formatNumeric(d.value)
		},
		cellDrillDownUrl: (d) => {
			return window.API_ENDPOINT + '/position/'+d.position_key+'/transaction'
		},
		cellDrillDown: (d) => {
			let htmlContent = `
			<table class='table table-hover'>
			<thead>
				<tr>
					<td style="text-align:center;width:6.5em;">time</td>
					<td style="text-align:right;">quantity</td>
					<td style="text-align:right;">px</td>
					<td style="text-align:right;">setl px</td>
					<td style="text-align:right;">value</td>
					<td style="text-align:center;">ccy</td>
					<td style="text-align:center;">source</td>
					<td style="text-align:center;">cp</td>
				</tr>
			</thead>
			<tbody>
			`
			for (var i = 0; i < d.length; i++) {
				let entry = d[i]
				if (entry.transaction_type != "SEC") continue
				htmlContent += `<tr>
					<td style="text-align:right;font-size:0.8em;">${moment.utc(entry.trade_datetime).format('YYYY-MM-DD<br/>HH:mm:ss')}</td>
					<td style="text-align:center;" ${entry.transaction_type == "SEC" ? "" : "colSpan=2" } >${entry.transaction_type == "SEC" ? numeral(entry.quantity).format('0,0[.][0]0') : entry.transaction_type }</td>
					${entry.transaction_type == "SEC" ? `<td style="text-align:right;">${numeral(entry.price).format('0,0[.][0]0')}</td>` : ""}
					<td style="text-align:right;">${numeral(entry.settlement_price).format('0,0[.][0]0')}</td>
					<td style="text-align:right;">${numeral(entry.cost).format('0,0[.][0]0')}</td>
					<td style="text-align:center;">${entry.settlement_currency}</td>
					<td style="text-align:center;">${entry.source}</td>
					<td style="text-align:center;font-size:0.8em;">${entry.execution_broker}</td>
				</tr>`
			}
			htmlContent += `
			</tbody>
			</table>`

			return htmlContent
		},
  	},
	{headerName: 'Notional%',field: "market_value_f_pct",width: 80,cellClass:"cellRight",suppressMenu: true, aggFunc: 'sum',
		cellClass: (d) => { return (d.value > 0 ? "positive cellRight" : (d.value < 0 ? "negative cellRight" : "cellRight")) },
		cellRenderer:(d) => {
			if (d.data == null) return d.value || ''
					return formatNumeric(d.value, '0.00%')
		},
  	},
	{headerName: 'Notional',field: "market_value_bk_ccy",width: 100,cellClass:"cellRight",suppressMenu: true, aggFunc: 'sum',
		cellClass: (d) => { return "multiline " + (d.value > 0 ? "positive cellRight" : (d.value < 0 ? "negative cellRight" : "cellRight")) },
		cellRenderer:(d) => {
	      if (d.data == null) return d.value || ''
				if (d.node.group) {
		      var html = '';  //d.data["pricefeed_last_price"]=120.12; d.data["pricefeed_size_last_trade"] = 1203;
					html += "<span>" +
									formatNumeric(d.value,'0,0') + "</span>";
					html += "<br/><span class='footnote' style='bottom: 1px; right: 5px;'>"
									+ d.node.allLeafChildren[0].data["book_ccy"] + "</span>";
					return html;
				}
	      var html = '';  //d.data["pricefeed_last_price"]=120.12; d.data["pricefeed_size_last_trade"] = 1203;
				html += "<span>" +
								formatNumeric(d.data["market_value"],'0,0') + "</span>";
				// if (d.data["ccy"] == 'ALL')
				html += "<br/><span class='footnote' style='bottom: 1px; right: 5px;'>"
								+ d.data["ccy"] + "</span>";
				return html;
    },
  },
  // Price Feed Quote ==================
	// {headerName: 'CCY',field: "pricefeed_crncy",width: 55,cellClass:"cellCenter"},
	{headerName: 'Last',field: "current_price",width: 70,suppressMenu: true,
	  cellClass: "multiline cellRight",
    cellRenderer:(d) => {
	      if (d.data == null) return d.value || ''
				let lastPx = formatNumeric(d.value, '0[.][0]0000000')

				let lastChg = ''
				if (d.data.price_divisor != 0 && d.data.open_price != 0) {
					lastChg = formatNumeric((d.data.current_price - d.data.open_price)/d.data.open_price, '0.000%')
				}

				var html = '';
				html += "<span>" + lastPx + "</span>";
				html += "<br/><span class='footnote "
				if ((d.data.current_price - d.data.open_price) < 0) {
					html += "negative"
				} else {
					html += "positive"
				}
				html += "' style='bottom: 1px; right: 5px;'>"
								+ lastChg + "</span>";
				return html;
    },
  },
	// {headerName: '% Change',field: "current_price",width: 70,cellClass:"cellRight",suppressMenu: true,
	// 	cellClass: (d) => { return ((d.data.current_price - d.data.open_price) >= 0 ? "positive cellRight" : "negative cellRight" : "cellRight") },
	// 	cellRenderer:(d) => {
	//       if (d.data == null) return d.value || ''
	// 			if (d.data.price_divisor == 0) return ''
	// 			if (d.data.open_price == 0) return ''
	// 			// return formatNumeric(((d.data.current_price*d.data.price_divisor) - d.data.open_price)/d.data.open_price, '0.00%')
	// 			return formatNumeric((d.data.current_price - d.data.open_price)/d.data.open_price, '0.000%')
  //   },
  // },
	{headerName: 'Sector',field: "sector",width: 100,},
	{headerName: 'Country',field: "country",width: 70,},
	// =======================================

	{headerName: 'Perf%Fund',field: "tdy_pl_bk_ccy",width: 70,cellClass:"cellRight",suppressMenu: true,
		cellClass: (d) => { return ((d.value) >= 0 ? "positive cellRight" : "negative cellRight") },
		cellRenderer:(d) => {
				if (d.data == null || d.api.fund == undefined || d.api.fund.open == 0) return ''
				// return formatNumeric(((d.data.current_price*d.data.price_divisor) - d.data.open_price)/d.data.open_price, '0.00%')
				return formatNumeric((d.data.tdy_pl_bk_ccy) / d.api.fund.open, '0.00%')
		},
	},
	{headerName: 'Contribution%',field: "tdy_pl_bk_ccy",width: 90,cellClass:"cellRight",suppressMenu: true,
		cellClass: (d) => { return ((d.value) >= 0 ? "positive cellRight" : "negative cellRight") },
		cellRenderer:(d) => {
				if (d.data == null || d.api.fund == undefined || d.api.fund.tdy_pl == 0) return ''
				// return formatNumeric(((d.data.current_price*d.data.price_divisor) - d.data.open_price)/d.data.open_price, '0.00%')
				return formatNumeric((d.data.tdy_pl_bk_ccy)/d.api.fund.tdy_pl, '0.000%')
		},
	},
	{headerName: 'TDY P&L',field: "tdy_pl_bk_ccy",width: 90,cellClass:"cellRight",suppressMenu: true, aggFunc: 'sum',
		cellClass: (d) => { return (d.value > 0 ? "positive cellRight" : (d.value < 0 ? "negative cellRight" : "cellRight")) + (d.node.group ? '' : ' hasDrillDown') },
		cellRenderer:(d) => { return formatNumeric(d.value,'0,0') },
		cellDrillDown: (entry) => {
			let htmlContent = `
			<table class='table table-hover'>
			<tbody>
			<tr>
				<td colSpan=2 style="font-size:1.2em;">Today P&L (${entry.book_ccy})</td>
			</tr>
			<tr>
				<td style="text-align:center;">current unit price</td>
				<td style="text-align:right;">${numeral(entry.current_price).format('0,0.00[0][0]')}</td>
			</tr>
			<tr>
				<td style="text-align:center;">price divisor</td>
				<td style="text-align:right;">${numeral(entry.price_divisor).format('0,0[.][0]0')}</td>
			</tr>
			<tr>
				<td style="text-align:center;">open price</td>
				<td style="text-align:right;">${numeral(entry.open_price).format('0,0.00[0][0]')}</td>
			</tr>
			<tr>
				<td style="text-align:center;">open quantity</td>
				<td style="text-align:right;">${numeral(entry.open_quantity).format('0,0[.][0]0')}</td>
			</tr>
			<tr>
				<td style="text-align:center;">sell quantity</td>
				<td style="text-align:right;">${numeral(entry.sell_quantity).format('0,0[.][0]0')}</td>
			</tr>
			<tr>
				<td style="text-align:center;">sell cost</td>
				<td style="text-align:right;">${numeral(entry.sell_cost).format('0,0.00[0][0]')}</td>
			</tr>
			<tr>
				<td style="text-align:center;">buy quantity</td>
				<td style="text-align:right;">${numeral(entry.buy_quantity).format('0,0[.][0]0')}</td>
			</tr>
			<tr>
				<td style="text-align:center;">buy cost</td>
				<td style="text-align:right;">${numeral(entry.buy_cost).format('0,0.00[0][0]')}</td>
			</tr>
			<tr>
				<td style="text-align:center;">current fx rate</td>
				<td style="text-align:right;">${numeral(entry.current_fx_rate).format('0,0.00[0][0]')}</td>
			</tr>
			</tbody>
			</table>`
			return htmlContent
		},
  },
	{headerName: 'MTD P&L',field: "mtd_pl_bk_ccy",width: 90,cellClass:"cellRight",suppressMenu: true, aggFunc: 'sum',
		cellClass: (d) => { return (d.value > 0 ? "positive cellRight" : (d.value < 0 ? "negative cellRight" : "cellRight")) + (d.node.group ? '' : ' hasDrillDown') },
		cellRenderer:(d) => { return formatNumeric(d.value,'0,0') },
		cellDrillDown: (entry) => {
			let htmlContent = `
			<table class='table table-hover'>
			<tbody>
			<tr>
				<td colSpan=2 style="font-size:1.2em;">Month P&L (${entry.book_ccy})</td>
			</tr>
			<tr>
				<td style="text-align:center;">open MTD realised p&l</td>
				<td style="text-align:right;">${numeral(entry.open_rl_pl_bk_ccy_mtd).format('0,0[.][0]0')}</td>
			</tr>
			<tr>
				<td style="text-align:center;">realised p&l</td>
				<td style="text-align:right;">${numeral(entry.realised_pl_bk_ccy).format('0,0[.][0]0')}</td>
			</tr>
			<tr>
				<td style="text-align:center;">UNrealised p&l</td>
				<td style="text-align:right;">${numeral(entry.unrl_pl_bk_ccy).format('0,0[.][0]0')}</td>
			</tr>
			</tbody>
			</table>`
			return htmlContent
		},
  },
	{headerName: 'YTD P&L',field: "ytd_pl_bk_ccy",width: 90,cellClass:"cellRight",suppressMenu: true, aggFunc: 'sum',
		cellClass: (d) => { return (d.value > 0 ? "positive cellRight" : (d.value < 0 ? "negative cellRight" : "cellRight")) + (d.node.group ? '' : ' hasDrillDown') },
		cellRenderer:(d) => { return formatNumeric(d.value,'0,0') },
		cellDrillDown: (entry) => {
			let htmlContent = `
			<table class='table table-hover'>
			<tbody>
			<tr>
				<td colSpan=2 style="font-size:1.2em;">Year P&L (${entry.book_ccy})</td>
			</tr>
			<tr>
				<td style="text-align:center;">open YTD realised p&l</td>
				<td style="text-align:right;">${numeral(entry.open_rl_pl_bk_ccy_ytd).format('0,0[.][0]0')}</td>
			</tr>
			<tr>
				<td style="text-align:center;">realised p&l</td>
				<td style="text-align:right;">${numeral(entry.realised_pl_bk_ccy).format('0,0[.][0]0')}</td>
			</tr>
			<tr>
				<td style="text-align:center;">UNrealised p&l</td>
				<td style="text-align:right;">${numeral(entry.unrl_pl_bk_ccy).format('0,0[.][0]0')}</td>
			</tr>
			</tbody>
			</table>`
			return htmlContent
		},
  },
	{headerName: 'Unrealised P&L',field: "unrl_pl_bk_ccy",width: 100,cellClass:"cellRight",suppressMenu: true, aggFunc: 'sum',
    cellClass: (d) => { return (d.value > 0 ? "positive cellRight" : (d.value < 0 ? "negative cellRight" : "cellRight")) + (d.node.group ? '' : ' hasDrillDown') },
    cellRenderer:(d) => {
      return formatNumeric(d.value,'0,0')
    },
		cellDrillDown: (entry) => {
			let htmlContent = `
			<table class='table table-hover'>
			<tbody>
			<tr>
				<td colSpan=2 style="font-size:1.2em;">Unrealised P&L (${entry.book_ccy})</td>
			</tr>
			<tr>
				<td style="text-align:center;">current unit price</td>
				<td style="text-align:right;">${numeral(entry.current_price).format('0,0[.][0]0')}</td>
			</tr>
			<tr>
				<td style="text-align:center;">price divisor</td>
				<td style="text-align:right;">${numeral(entry.price_divisor).format('0,0[.][0]0')}</td>
			</tr>
			<tr>
				<td style="text-align:center;">current unit cost</td>
				<td style="text-align:right;">${numeral(entry.current_unit_cost).format('0,0[.][0]0')}</td>
			</tr>
			<tr>
				<td style="text-align:center;">current quantity</td>
				<td style="text-align:right;">${numeral(entry.current_quantity).format('0,0[.][0]0')}</td>
			</tr>
			</tbody>
			</table>`
			return htmlContent
		},
  },
	{headerName: 'Trade P&L',field: "trade_pl_bk_ccy",width: 100,cellClass:"cellRight",suppressMenu: true, aggFunc: 'sum',
    cellClass: (d) => { return (d.value > 0 ? "positive cellRight" : (d.value < 0 ? "negative cellRight" : "cellRight")) + (d.node.group ? '' : ' hasDrillDown') },
		cellRenderer:(d) => {
      return formatNumeric(d.value,'0,0')
    },
		cellDrillDown: (entry) => {
			let htmlContent = `
			<table class='table table-hover'>
			<tbody>
			<tr>
				<td colSpan=2 style="font-size:1.2em;">Trade P&L (${entry.book_ccy})</td>
			</tr>
			<tr>
				<td style="text-align:center;">Notional</td>
				<td style="text-align:right;">${numeral(entry.market_value_bk_ccy).format('0,0[.][0]0')}</td>
			</tr>
			<tr>
				<td style="text-align:center;">Cost of Buys</td>
				<td style="text-align:right;">${numeral(entry.buy_cost_bk_ccy).format('0,0[.][0]0')}</td>
			</tr>
			<tr>
				<td style="text-align:center;">Cost of Sells</td>
				<td style="text-align:right;">${numeral(entry.sell_cost_bk_ccy).format('0,0[.][0]0')}</td>
			</tr>
			<tr>
				<td style="text-align:center;">Open Notional</td>
				<td style="text-align:right;">${numeral(entry.open_market_value_bk_ccy).format('0,0[.][0]0')}</td>
			</tr>
			<tr>
				<td style="text-align:center;">FX P&L</td>
				<td style="text-align:right;">${numeral(entry.fx_pl_bk_ccy).format('0,0[.][0]0')}</td>
			</tr>
			</tbody>
			</table>`
			return htmlContent
		},
  },
	{headerName: 'FX P&L',field: "fx_pl_bk_ccy",width: 90,cellClass:"cellRight",suppressMenu: true, aggFunc: 'sum',
    cellClass: (d) => { return (d.value > 0 ? "positive cellRight" : (d.value < 0 ? "negative cellRight" : "cellRight")) + (d.node.group ? '' : ' hasDrillDown') },
    cellRenderer:(d) => {
      return formatNumeric(d.value,'0,0')
    },
		cellDrillDown: (entry) => {
			let htmlContent = `
			<table class='table table-hover'>
			<tbody>
			<tr>
				<td colSpan=2 style="font-size:1.2em;">FX P&L (${entry.book_ccy})</td>
			</tr>
			<tr>
				<td style="text-align:center;">Open Cost (${entry.book_ccy})</td>
				<td style="text-align:right;">${numeral(entry.open_cost_bk_ccy).format('0,0[.][0]0')}</td>
			</tr>
			<tr>
				<td style="text-align:center;">Current FX Rate</td>
				<td style="text-align:right;">${numeral(entry.current_fx_rate).format('0,0[.][0]000')}</td>
			</tr>
			<tr>
				<td style="text-align:center;">Open FX Rate</td>
				<td style="text-align:right;">${numeral(entry.open_fx_rate).format('0,0[.][0]000')}</td>
			</tr>
			<tr>
				<td style="text-align:center;">Cost of Buys (${entry.ccy})</td>
				<td style="text-align:right;">${numeral(entry.buy_cost).format('0,0[.][0]0')}</td>
			</tr>
			<tr>
				<td style="text-align:center;">Cost of Sells (${entry.ccy})</td>
				<td style="text-align:right;">${numeral(entry.sell_cost).format('0,0[.][0]0')}</td>
			</tr>
			<tr>
				<td style="text-align:center;">Cost of Buys (${entry.book_ccy})</td>
				<td style="text-align:right;">${numeral(entry.buy_cost_bk_ccy).format('0,0[.][0]0')}</td>
			</tr>
			<tr>
				<td style="text-align:center;">Cost of Sells (${entry.book_ccy})</td>
				<td style="text-align:right;">${numeral(entry.sell_cost_bk_ccy).format('0,0[.][0]0')}</td>
			</tr>
			<tr>
				<td style="text-align:center;">Carry P&L (${entry.book_ccy})</td>
				<td style="text-align:right;">${numeral(entry.carry_pl_bk_ccy).format('0,0[.][0]0')}</td>
			</tr>
			</tbody>
			</table>`
			return htmlContent
		},
  },
	{headerName: 'Unit Cost',field: "current_unit_cost",width: 80,cellClass:"cellRight",suppressMenu: true,
    // cellClass: (d) => { return (d.value > 0 ? "positive cellRight" : (d.value < 0 ? "negative cellRight" : "cellRight")) },
    cellRenderer:(d) => {
      return formatNumeric(d.value,'0.00[0][0]')
    },
  },
	{headerName: 'Open Quantity',field: "open_quantity",width: 100,cellClass:"cellRight",suppressMenu: true,
    cellClass: (d) => { return (d.value > 0 ? "positive cellRight" : (d.value < 0 ? "negative cellRight" : "cellRight")) },
    cellRenderer:(d) => {
      return formatNumeric(d.value)
    },
  },
	{headerName: 'Target Quantity',field: "target_quantity",width: 100,cellClass:"cellRight",suppressMenu: true,
    cellClass: (d) => { return (d.value > 0 ? "positive cellRight" : (d.value < 0 ? "negative cellRight" : "cellRight")) },
    cellRenderer:(d) => {
	  return formatNumeric(d.value, '0,0')
    },
  },
	{headerName: 'Total Quantity',field: "current_plus_filled_quantity",width: 100,cellClass:"cellRight",suppressMenu: true,
    cellClass: (d) => { return (d.value > 0 ? "positive cellRight" : (d.value < 0 ? "negative cellRight" : "cellRight")) },
    cellRenderer:(d) => {
		return formatNumeric(d.value, '0,0')
    },
  },
	{headerName: 'Working Filled',field: "working_cum_quantity",width: 100,cellClass:"cellRight",suppressMenu: true,
    cellClass: (d) => { return (d.value > 0 ? "positive cellRight" : (d.value < 0 ? "negative cellRight" : "cellRight")) },
    cellRenderer:(d) => {
		return formatNumeric(d.value, '0,0')
    },
  },
	{headerName: 'Working P&L', field: "working_pl_bk_ccy", width: 100, cellClass: "cellRight", suppressMenu: true, aggFunc: 'sum',
	    cellClass: (d) => { return (d.value > 0 ? "positive cellRight" : (d.value < 0 ? "negative cellRight" : "cellRight")) },
		cellRenderer:(d) => {
			return formatNumeric(d.value, '0,0')
		},
	},
	{headerName: 'TDY+WRK P&L', field: "tdy_wrk_pnl_bk_ccy", width: 100, cellClass: "cellRight", suppressMenu: true, aggFunc: 'sum',
	    cellClass: (d) => { return (d.value > 0 ? "positive cellRight" : (d.value < 0 ? "negative cellRight" : "cellRight")) },
		cellRenderer:(d) => {
			return formatNumeric(d.value, '0,0')
		},
	},
	{headerName: 'MktCap',field: "market_cap_type",width: 70,},
	{headerName: 'Long/Short',field: "market_value_bk_ccy",width: 70,suppressMenu: true,
    cellRenderer:(d) => {
	      if (d.data == null) return d.value || ''
				return (d.value >= 0 ? 'Long' : 'Short')
    },
  },
]

export default class PositionMonitor extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			loaded : false,
			fund_id: 0,
      		orders : [],
			fundSummary: {},

			savedLayout : props.savedLayout || {},
		}

		// websocket connections
    	this.sockets = []
	}

	componentDidMount() {
    // Layout
    $(this.refs.splitPanel).kendoSplitter({
        orientation: "vertical",
        panes: [
            { collapsible: false, resizable: false, size: "64px" },
            { collapsible: true, collapsed: false, size: this.state.savedLayout.inspector_pane_size || '20%', min: "100px" },
            { collapsible: true },
        ],
        resize: (e) => {
					this.state.savedLayout.inspector_pane_size = $(this.refs.splitPanel).data("kendoSplitter").size("> .k-pane:last")
					this.saveLayout()
            // self.refs.slickGrid.handleResize();
					this.renderBarChart()
        }
    });

		this.subscribePLQueryResult()

		// UI Components
		api('/fund')
			.then( (funds) => {
				$(this.refs.optFundView).kendoDropDownList({
						dataSource: _.map(funds, (f) => { return {text: f.fund_name, id: f.fund_id} }),
						dataTextField: "text", dataValueField: "id",
						index: 0,
						change: (e) => {
							var fund_id = $(this.refs.optFundView).data("kendoDropDownList").value()
	this.__pnl_drilldown_sum_inited = {}
							this.setState({fund_id : fund_id}, () => {
								delete this._last_chart_start_time
								delete this._FUND_PL_TS_results
								this.subscribeFund()
								this.renderTimeChart()
								this.reloadView()

							console.log("!!!!!! fund_id")
							})
						}
				}).data("kendoDropDownList").list.addClass('fit-to-content')
	this.__pnl_drilldown_sum_inited = {}
				this.setState({fund_id : funds[0].fund_id}, () => {
					this.subscribeFund()
					this.reloadView()
				})
			})

		this.state.groupby = ["book_name"]
		var optGroupByOnSelect = (e) => {
			var groups = [
				$(this.refs.optGroupBy).data("kendoDropDownList").value(),
				$(this.refs.optGroupBy2).data("kendoDropDownList").value()
			]
			if (groups[0] == groups[1] || groups[1] == '')
				groups = [groups[0]]

			if (groups[0] !== this.state.groupby[0]) {
				// clear filter
				let f = this.positionGrid.getFilterInstance(this.state.groupby[0])
				if (f) {
					f.selectEverything();
					this.positionGrid.onFilterChanged()
				}
			}
			this.state.groupby = groups
			if (this._tmrResetView == undefined) {
				this._tmrResetView = setTimeout(() => {
					this.reloadView()
					delete this._tmrResetView
				}, 300)
			}
		}
		$(this.refs.optGroupBy).kendoDropDownList({
				dataSource: [
					{id : "book_name", text : 'Book'},
					{id : "tag", text : 'Tag'},
					{id : "symbol", text : 'Symbol'},
					{id : "ccy", text : 'Currency'},
					{id : "country", text : 'Country'},
					{id : "sector", text : 'Sector'},
					{id : "industry", text : 'Industry'},
					{id : "market_cap_type", text : 'MktCap'},
					{id : "long_short", text : 'Long/Short'},
					{id : "product_type", text : 'Instrument'},
				],
				dataTextField: "text",
				dataValueField: "id",
				index: 0, change: optGroupByOnSelect
		}).data("kendoDropDownList").select(0);
		$(this.refs.optGroupBy2).kendoDropDownList({
				dataSource: [
					{id : "", text : '-'},
					{id : "book_name", text : 'Book'},
					{id : "tag", text : 'Tag'},
					{id : "symbol", text : 'Symbol'},
					{id : "ccy", text : 'Currency'},
					{id : "country", text : 'Country'},
					{id : "sector", text : 'Sector'},
					{id : "industry", text : 'Industry'},
					{id : "market_cap_type", text : 'MktCap'},
					{id : "long_short", text : 'Long/Short'},
					{id : "product_type", text : 'Instrument'},
				],
				dataTextField: "text",
				dataValueField: "id",
				index: 0, change: optGroupByOnSelect
		}).data("kendoDropDownList").select(0);


    // subscribe to realtime Feed
    realtime().then( (socket) => {
		this._position_socket = socket
		socket.onclose = (e) => {
			if (e.wasClean != true)
				raiseAlert("CONNECTION LOST: " + e.code + " " + e.reason + " :_position_socket")
		}
		socket.onjson = (message) => {
			if (!(message.id)) return
			let posNode = undefined
			this.positionGrid.forEachNode( (node) => {
				let data = node.data
				if (data.position_key == message.id)
					posNode = node
			})
			if (posNode) {
				message.market_value_f_pct = message.market_value_bk_ccy / this.state.fundSummary.nav
				let update = _.pick(message, _.keys(posNode.data))
				// console.log("POS UPDATE", message.id, update)
				Object.assign(posNode.data, update)
				this.positionGrid.redrawRows({ rowNodes: [posNode] })
			}
		}
		this.sockets.push(socket)
    }).catch( (err) => { console.log(err) })

	}

	subscribePLQueryResult() {
	    // subscribe to realtime Feed
	    realtime().then( (socket) => {
			this._socket = socket
			socket.onclose = (e) => {
				if (e.wasClean != true)
					raiseAlert("CONNECTION LOST: " + e.code + " " + e.reason + " :_queryPL_socket")
			}
			socket.onjson = (message) => {
				if (message.op == "_queryPL") {
					let result = []
					try {
						result = JSON.parse(message.result)
					} catch(e) { console.log(e, m.data); return; }


					if (message.cid == "FUND_VIEW") {
//console.log("FUND_VIEW ==> ", result)
						if (result.length > 0 && result[0].fund_id) {
							this.processFundViewMessage(result[0])
						}
					}

					if (message.cid == "FUND_PL_TS") {
// console.log("FUND_PL_TS ==> ", result)
						for (var i = 0; i < result.length; i++)
								result[i].date = moment.utc(result[i].date).toDate()

						if (! this._FUND_PL_TS_results)
							this._FUND_PL_TS_results = result
						else
							if (result.length > 0) {
								let new_points = this._FUND_PL_TS_results
								let first_point = result[0]
								if (first_point.date) {
									for (var i = new_points.length - 1; i >= 0 ; i--) {
										let a = new_points[i]
										if (+a.date < +first_point.date) {
											this._FUND_PL_TS_results = new_points.concat(result)
											break
										} else {
											new_points.pop()
										}
									}
								}
							}

							this.renderTimeChart()
							return
					}
				}
	      }
				this.sockets.push(socket)

	    }).catch( (err) => { console.log(err) })
	}

	subscribeFund() {
		if (this._fund_socket && this._fund_socket != "PENDING") {
			if (this._fund_socket._current_fund_id) {
				this._fund_socket.unsubscribe("pl.Fund." + this._fund_socket._current_fund_id)
			}
			this._fund_socket.subscribe("pl.Fund." + this.state.fund_id)
			this._fund_socket._current_fund_id = this.state.fund_id

			this._socket.send(JSON.stringify({
					op : "_queryPL",
					cid: "FUND_VIEW",
					sql : `SELECT
										 *
									FROM fund_view
									WHERE fund_id = ${this.state.fund_id}`,
			}))
			this.syncFundPLHistory()
		} else {
			this._fund_socket = "PENDING"
			realtime().then( (socket) => {
				this._fund_socket = socket
				socket.onclose = (e) => {
					if (e.wasClean != true)
						raiseAlert("CONNECTION LOST: " + e.code + " " + e.reason + " :_fund_socket")
				}
				socket.onjson = (message) => {
					if (message.fund_id && message.fund_id == this.state.fund_id) {
						this.processFundViewMessage(message)
					}
				}
				this.sockets.push(socket)
				this.subscribeFund()
			}).catch( (err) => { console.log(err) })
		}
	}

	processFundViewMessage(message) {
		// Update Fund Summary Panel
		this.setState({
			loaded : true,
			fundSummary : message
		},
		() => {
			this.refs.summaryWidget.classList.add("loaded")
			this.positionGrid.fund = this.state.fundSummary
		})

		// Update Chart last point
		if (this._FUND_PL_TS_results && this._FUND_PL_TS_results.length > 0) {
			this._FUND_PL_TS_results[this._FUND_PL_TS_results.length-1].v = message.tdy_pl
			this.renderTimeChart()
		}
		this.syncFundPLHistory()

		// Update aggregations
		if (this._timer_refresh_agg) {
			//skip
		} else {
			this._timer_refresh_agg = setTimeout(() => {
				delete this._timer_refresh_agg
				this.__timer_refresh_agg_uuid = '' + this.state.fund_id
				for (var g = 0; g < this.state.groupby.length; g++) {
					this.__timer_refresh_agg_uuid += this.state.groupby[g]
				}
				let __uuid = '' + this.__timer_refresh_agg_uuid
				api('/position/view', {
						method: 'POST',
						body : JSON.stringify({
							include_drilldown: false,
							groups : this.state.groupby,
							funds  : [+ this.state.fund_id],
						})
					})
					.then( (res) => {
						if (__uuid != this.__timer_refresh_agg_uuid) return
						delete this.__timer_refresh_agg_uuid
						if (Array.isArray(res)) {
							let refreshRows = []
							this.positionGrid.forEachNode( (node) => {
								if (!node.group) return
								let data = node.data

								for (var i = res.length-1; i >= 0; i--) {
									let row = res[i]
									let match = true
									for (var g = 0; g < this.state.groupby.length; g++) {
										let group = this.state.groupby[g]
										if (row[group] == null || row[group] != data[group]) {
											match = false
											break
										}
										if (data._key == group) break
									}

									if (match) {
										Object.assign(node.data, row)
										refreshRows.push(node)
										break
									}
								}
							})

							if (refreshRows.length > 0) {
								// try {
								// 		this.positionGrid.redrawRows({ rowNodes: refreshRows })
								// } catch(e) { console.log(e, refreshRows); return; }
								this.renderBarChart()
							}
						}
					})
			}, 300)
		}

	}

	syncFundPLHistory() {
		if (! this._last_chart_start_time) {
			this._last_chart_start_time = moment().startOf('day').add(7, 'hours') //moment().subtract(15, 'hours')
			this._last_chart_query_time = this._last_chart_start_time
		}
		if (moment().diff(this._last_chart_query_time, 'minutes') > 1) {
			this._socket.send(JSON.stringify({
					op : "_queryPL",
					cid: "FUND_PL_TS",
					sql : `SELECT
										 update_time AT TIME ZONE 'UTC' AS date,
										 tdy_pl      AS v
									FROM fund_tdy_pl_ts
									WHERE update_time > '${this._last_chart_start_time.toISOString()}':: TIMESTAMP WITH TIME ZONE
									AND fund_id = ${this.state.fund_id}
									ORDER BY update_time`,
			}))
			this._last_chart_start_time = moment().subtract(1, 'minute')
			this._last_chart_query_time = moment()
		}
	}

	reloadView() {
			// retireve view
			var groups = this.state.groupby
			api('/position/view', {
					method: 'POST',
					body : JSON.stringify({
						groups : groups,
						funds  : [+ this.state.fund_id],
					})
				})
				.then( (res) => {
					if (res == null || res == undefined)
						res = []
					if (Array.isArray(res)) {

						var rootNode = undefined
						var cursorNode = undefined
						var leafMode = false
						for (var i = res.length-1; i >= 0 ; i--) {
							var row = res[i]
							if (rootNode === undefined) {
								rootNode = row; cursorNode = row;
								cursorNode._children = []
								continue
							}
							if (row._children === null) {
								if (leafMode == true) {
									// back up a level
									cursorNode = cursorNode._parent
									cursorNode._children.push(row)
									leafMode = false
								} else {
									// next level down
									cursorNode._children.push(row)
								}
								row._parent = cursorNode
								row._children = []
								cursorNode = row
							} else {
								leafMode = true
								cursorNode._children.push(row)
							}

							//tag group Key
							for (var g = 0; g < groups.length; g++) {
								if (row[groups[g]] === null) break
								row._group = row[groups[g]]
								row._key   = groups[g]
							}

						}
						console.log("RESULT: ", rootNode)
						this.setState({
							position_cube : rootNode._children,
						}, () => {
						 	this.positionGrid.setRowData(rootNode._children)
							this.positionGridColumns.autoSizeColumn("_group")
							this.renderBarChart()
						})
					}
				})
	}

	renderTimeChart() {
		let data_src = this._FUND_PL_TS_results
		if (data_src == undefined) data_src = []
		// METRICS & BOUNDS
		let margin = {top: 3, right: 20, bottom: 25, left: 20};
		let bounds = this.refs.chart.getBoundingClientRect(),
		    width = bounds.width - margin.left - margin.right,
		    height = bounds.height - margin.top - margin.bottom;
		if (height < 10) return

		// MARKERS - Exchange opening times
		let markers = []
		if (data_src.length > 0) {
			let todate = moment().format('YYYY-MM-DD') + ' '
			let localZone = moment.tz.guess()
			let LSE_OPEN = moment.tz(todate + "08:00", "Europe/London").tz(localZone)
			let NY_OPEN = moment.tz(todate + "09:30", "America/New_York").tz(localZone)

			if (moment(data_src[0].date).isBefore(LSE_OPEN))
				markers.push({
						'date': LSE_OPEN.toDate(),
						'label': 'LSE'
				})
			if (moment(data_src[data_src.length - 1].date).isAfter(NY_OPEN))
				markers.push({
						'date': NY_OPEN.toDate(),
						'label': 'NYSE'
				})
		}

		// RENDER
		try {
				MG.data_graphic({
							data: data_src,
							// buffer: 0, left: 25, right: 0, top: 0, bottom: 0,
							top: 25, bottom: 30,
							target: this.refs.timeline,
							// width: width,
							// height: height,
							full_height: true,  full_width: true,
							show_tooltips: false,
							x_accessor: 'date',
							y_accessor: 'v',
							min_y_from_data: true,
							area: false,
							color: '#99c542',
							markers: markers,
							show_secondary_x_label: false,
							transition_on_update: false,
							//animate_on_load: true,
					})
		 } catch(e) {  }
	}
	renderBarChart() {
		if (this.state.position_cube == undefined) return
		// Controls
		if (! this.__bar_groupby_rendered) {
			this.__bar_groupby_rendered = $(this.refs.optBarBy).kendoDropDownList({
					dataSource: [
						{id : "tdy_pl_bk_ccy", text : 'TDY P&L'},
						{id : "market_value_bk_ccy", text : 'MktVal'},
						{id : "market_value_f_pct", text : 'Notnl%'},
						{id : "unrl_pl_bk_ccy", text : 'Unrl P&L'},
						{id : "mtd_pl_bk_ccy", text : 'MTD P&L'},
						{id : "ytd_pl_bk_ccy", text : 'YTD P&L'},
					],
					dataTextField: "text",
					dataValueField: "id",
					index: 0,
					change: () => this.renderBarChart()
			}).data("kendoDropDownList");
		}
		// METRICS & BOUNDS
		var margin = {top: 3, right: 20, bottom: 25, left: 20};
		var bounds = this.refs.chart.getBoundingClientRect(),
		    width = bounds.width - margin.left - margin.right,
		    height = bounds.height - margin.top - margin.bottom;

		if (height < 10) return
		let MIN_BAR_HEIGHT = 14,
			  MAX_BAR_HEIGHT = 25
		// CLEAN DATA
		let data = [], field_key = this.__bar_groupby_rendered.value()
		this.state.position_cube.forEach( (p) => {
			// if (data.length > (height / MIN_BAR_HEIGHT)) return
			if (p._group && p[field_key] !== undefined) {
				data.push({ name: p._group, value: p[field_key]})
			}
		})
		// CHART
		var chart = d3.select(this.refs.chart)
		    .style("margin-left", margin.left)
		    .style("overflow", 'visible')
		    // .attr("width", width)
		    // .attr("height", height);
		chart.selectAll("g").remove()
		// SCALES
		var x = d3.scaleLinear()
		    			.range([0, width]);
		var y = d3.scaleBand()
					    .rangeRound([0, height])
					    .paddingInner(0.05);
		let categories = data.map((d) => d.name)
		if (categories.length > (height / MIN_BAR_HEIGHT)) { // Remove 0 values if more item than container size
			 data = data.filter( c => (Math.abs(c.value) > 0.005) )
			 categories = data.map((d) => d.name)
		}
		while (categories.length < (height / MAX_BAR_HEIGHT)) categories.unshift("___" + categories.length)
		x.domain([Math.min(0, d3.min(data, (d) => d.value)), Math.max(0,d3.max(data, (d) => d.value))]);
		y.domain(categories)
		// BAR RECT
		var onBarClick = (d,i) => {
				let f = this.positionGrid.getFilterInstance(this.state.groupby[0])
				if (f) {
					f.selectNothing()
					f.selectValue(d.name)
					this.positionGrid.onFilterChanged()
					this.positionGrid.expandAll()
				}
		}
		var onClearSelection = () => {
				let f = this.positionGrid.getFilterInstance(this.state.groupby[0])
				if (f) {
					f.selectEverything();
					this.positionGrid.onFilterChanged()
					this.positionGrid.collapseAll()
				}
		}
	  var bar = chart.selectAll("g")
	      .data(data)
	    .enter().append("g")
				.attr("class", (d) => "bar")
	      .attr("transform", (d) => "translate(0, " + y(d.name) + ")" )
        .on("click", function(d,i) {
					if (this.classList.contains("active")) {
						this.classList.remove("active")
						onClearSelection()
						return
					}
					chart.selectAll("g.bar").attr("class", (d) => "bar")
					this.classList.add("active")
					onBarClick(d,i)
        })

	  bar.append("rect")
				.attr("class", (d) => "bar bar-" + (d.value < 0 ? "negative" : "positive") )
				// .style("fill", (d) => (d.value < 0 ? "#f96947" : "#16d364") )
	      .attr("x", (d) => x(Math.min(0, d.value)) )
	      .attr("width", (d) => Math.max(1, Math.abs(x(d.value) - x(0))) )
	      .attr("height", y.bandwidth());
		// BAR value label
		let format = ",d"
		if (field_key == "market_value_f_pct") format = ".2%"
		bar.append("text")
	      .attr("class", (d) => "label label-" + (d.value < 0 ? "negative" : "positive") )
				.style("text-anchor",  (d) => (d.value < 0 ? 'end' : 'initial') )
	      .attr("y", y.bandwidth() / 2 )
				.append("tspan")
			      .attr("class", "label-value")
			      .attr("dy", ".3em")
			      .text(function(d) { return d3.format(format)(d.value); })
			      .attr("x", (d) => x(0) + ( (d.value < 0 ? -1 : 1) ))
		// BAR category label
	  bar.append("rect")
				.attr("class", "label-border")
				.attr("x", width + 5)
	      .attr("width", (d) => 6.5 * d.name.length )
	      .attr("height", y.bandwidth());
		bar.append("text")
	      .attr("class", (d) => "label" )
	      .attr("y", y.bandwidth() / 2 )
				.attr("x", width + 10)
				.append("tspan")
			      .attr("class", "label-value")
			      .attr("dy", ".3em")
			      .text( (d) => d.name )
		// AXIS
		var xAxis = d3.axisBottom(x).tickSize(3)
	  chart.append("g")
	      .attr("class", "x axis")
	      .attr("transform", "translate(0," + height + ")")
	      .call(xAxis)
	}

	popupFundPnlBreakdown(el, period) {
		var self = this
		this.__pnl_drilldown_sum_inited = this.__pnl_drilldown_sum_inited || {}
		// if (this.__tdy_sum_inited || this.state.fund_id <= 0) return
		if (this.__pnl_drilldown_sum_inited[period]) return
		this.__pnl_drilldown_sum_inited[period] = true

		console.log("----> rebuild popup, fund_id = ", this.state.fund_id)
		let $el = $(el)
		let popup = $el.data("plugin_webuiPopover")
		if (popup) {
			popup.destroy()
		}
		$el.webuiPopover({
			placement: 'vertical',
			width: 235,
			cache: false,
			multi: true,
			closeable: false,
			trigger: 'hover',
			delay: {
				show: null,
        hide: 100
    	},
			// onHide: function($element) { $($element).remove() },
	        type: 'async',
	        url: window.API_ENDPOINT + '/position/ledger?fund=x&time_period='+period,
	        async: {
	          before: function(that, xhr, settings) {
	        	console.log(settings)
	        	settings.url = settings.url.replace('fund=x', 'fund=' + self.state.fund_id + '')
	            xhr.setRequestHeader('Authorization', (window.user ? window.user.token : localStorage.token))
	          }
	        },
	        content:  (d) => {
	        	if (!d || d.length == 0) return "N/A"

				let htmlContent = `
				<div>${period} ledger breakdown</div>
				<div class="separator"></div>
				<table class='table table-hover'>
				<tbody>
				`
				for (var i = 0; i < d.length; i++) {
					let entry = d[i]
					htmlContent += `<tr>
						<td style="text-align:left;">${entry.transaction_type}</td>
						<td style="text-align:right;">${numeral(entry.value).format('0,0[.][0][0]')}</td>
					</tr>`
				}
				htmlContent += `
				</tbody>
				</table>`

				return htmlContent
			},
		})
	}

	componentWillUnmount() {
    for (var i = 0; i < this.sockets.length; i++) {
      this.sockets[i].close()
    }
    delete this.sockets
		clearInterval(this._reload_pos_timer)
	}

	saveLayout() {
		if (window.updateLayout) {
			window.updateLayout(this.state.savedLayout)
		}
	}

	render() {
		let SummaryControlLayoutStyle = {
			minWidth: '6em',
    	paddingLeft: "1em",
			fontSize: "0.9em",
		}
		let SummaryControlLayoutBorderStyle = {
			minWidth: '6em',
    	paddingLeft: "1em",
			paddingRight: "1em",
			borderRight: "solid 1px #3e3e3e",
			fontSize: "0.9em",
		}
		return (
      <div ref="splitPanel" style={{ height: '100%', width: '100%', position: 'absolute'}}>
				  <div ref="paneSummary" style={{ verticalAlign: 'center' }}>
						<table ref="summaryWidget" className="widget" style={{ fontSize: '1em', height: '100%', width: '80%', maxWidth: 1200 }}>
      				<tr style={{ verticalAlign: 'center' }}>
								<td rowSpan={2} style={{
    							//padding: "1em",
									//paddingRight: 0,
									padding: "0.5em",
									verticalAlign: "top",
									width: 170,
    							borderRight: "solid 1px #3e3e3e"
								}}>
									<select ref="optFundView" style={{marginLeft: '0.5em',width:160}}></select>
									<div style={{fontSize:'0.8em', padding: '0.5em'}}>
										<select ref="optGroupBy" style={{width:80}}></select>
									  <select ref="optGroupBy2" style={{width:80}}></select>
									</div>
								</td>
								<td style={SummaryControlLayoutBorderStyle}><div className="labelCell"><label>Open</label><span>{
									formatNumeric(this.state.fundSummary.open)
								}</span></div></td>
								<td style={SummaryControlLayoutStyle}><div className="labelCell"><label>Position Long</label><span>{
									formatNumeric(this.state.fundSummary.exposure_long)
								}</span></div></td>
								<td style={SummaryControlLayoutStyle}><div className="labelCell"><label>Net Exposure</label><span>{
									formatNumeric(this.state.fundSummary.net_exposure)
								}</span></div></td>
								<td style={SummaryControlLayoutStyle}
									ref={ el => {this.popupFundPnlBreakdown(el, 'YTD')} }><div className={ "labelCell" + (
									this.state.fundSummary.ytd_pl < 0 ? " negative" : " positive"
								) }><label>YTD P&L</label><span>{
									formatNumeric(this.state.fundSummary.ytd_pl / (this.state.fundSummary.open), "0.00%")
								}</span><span style={{marginRight: "1em"}}>{
									formatNumeric(this.state.fundSummary.ytd_pl)
								}</span></div></td>
								<td style={SummaryControlLayoutBorderStyle}
									ref={ el => {this.popupFundPnlBreakdown(el, 'MTD')} }><div className={ "labelCell" + (
									this.state.fundSummary.mtd_pl < 0 ? " negative" : " positive"
								) }><label>MTD P&L</label><span>{
									formatNumeric(this.state.fundSummary.mtd_pl / (this.state.fundSummary.open), "0.00%")
								}</span><span style={{marginRight: "1em"}}>{
									formatNumeric(this.state.fundSummary.mtd_pl)
								}</span></div></td>
								<td rowSpan={2} style={{
    							borderRight: "solid 1px #3e3e3e",
									fontSize: "0.6em",
								}}><div ref="summaryWidgetHistoryChart" style={{marginRight: -50}}></div></td>
							</tr>
	      			<tr style={{ verticalAlign: 'center' }}>
								<td style={SummaryControlLayoutBorderStyle}
									ref={ el => {this.popupFundPnlBreakdown(el, 'ITD')} }><div className="labelCell"><label>N.A.V</label><span>{
									formatNumeric(this.state.fundSummary.nav)
								}</span></div></td>
								<td style={SummaryControlLayoutStyle}><div className="labelCell"><label>Position Short</label><span>{
									formatNumeric(this.state.fundSummary.exposure_short)
								}</span></div></td>
								<td style={SummaryControlLayoutStyle}><div className="labelCell"><label>Gross Exposure</label><span>{
									formatNumeric(this.state.fundSummary.gross_exposure)
								}</span></div></td>
								<td style={SummaryControlLayoutStyle}
									ref={ el => {this.popupFundPnlBreakdown(el, 'QTD')} }><div className={ "labelCell" + (
									this.state.fundSummary.qtd_pl < 0 ? " negative" : " positive"
								) }><label>QTD P&L</label><span>{
									formatNumeric(this.state.fundSummary.qtd_pl / (this.state.fundSummary.open), "0.00%")
								}</span><span style={{marginRight: "1em"}}>{
									formatNumeric(this.state.fundSummary.qtd_pl)
								}</span></div></td>
								<td style={SummaryControlLayoutBorderStyle}
									ref={ el => {this.popupFundPnlBreakdown(el, 'TDY')} }><div className={ "labelCell" + (
									this.state.fundSummary.tdy_pl < 0 ? " negative" : " positive"
								) }><label>TDY P&L</label><span>{
									formatNumeric(this.state.fundSummary.tdy_pl / (this.state.fundSummary.open), "0.00%")
								}</span><span style={{marginRight: "1em"}}>{
									formatNumeric(this.state.fundSummary.tdy_pl)
								}</span></div></td>
							</tr>
      			</table>
					</div>
          <div ref="paneChart">
              <div ref="plugin1">
                  <div className="panel-heading">
                      <a>
                        <span>{ 'Chart' }</span>
                      </a>
                  </div>
                  <div ref="chartContainer" style={{height: 'calc(100% - 13px)', position: 'absolute', width: '100%', display:"flex"}}>
										<div ref="timeline" className="chart" style={{width: "50%",maxWidth: 800,minWidth: 300, borderRight: 'solid 1px #2d2d2d'}}/>
										<svg ref="chart" className="chart" style={{width: "40%",maxWidth: 500,minWidth: 300}}></svg>
										<div style={{fontSize:'0.8em', padding: '0.5em',marginLeft: -35}}>
											<select ref="optBarBy" style={{width:80,bottom:-2,position:'absolute'}}></select>
										</div>
                  </div>
              </div>
          </div>
          <div ref="paneTickets" id="paneTickets">
              <div ref="datagridContainer" className="ag-grid" style={{ height: '100%', width: '100%', position: 'relative'}}>
								<AgGridReact
	                onGridReady={ (args) => { this.positionGrid = args.api; this.positionGridColumns = args.columnApi; /* args.api.sizeColumnsToFit() */
										if(localStorage.PositionMonitorColState ){
											console.log("Saved Grid State: " ,localStorage.PositionMonitorColState )
											try{
												console.log("Loading Saved Grid State")
												this.positionGridColumns.setColumnState(JSON.parse(localStorage.PositionMonitorColState))
												console.log("Saved Grid State Loaded")
										} catch(e) { console.log(e); return; }
										}}
								}
	                gridOptions={{
	                    enableColResize: true,
											suppressLoadingOverlay: true,

											getNodeChildDetails: (rowItem) => {
												if (rowItem._children) {
													return {
														group: true,
														field: '_group',
														key: rowItem._group,
														children: rowItem._children,
													}
												}
											},

											getContextMenuItems: (params) => {
												console.log("CREATE MENU", params)
												var result = [
													{
														name: 'Export All As CSV..',
														action: function () { params.api.exportDataAsCsv({fileName: "Positions_"+moment().format('YYYY_MM_DD')}) }
													},
													{
														name: 'Save Column Layout..',
														action: function () {
															//Save Column Layout
															try{
																var colState = JSON.stringify(params.columnApi.getColumnState())
														    console.log("colState: ", colState)
																localStorage.PositionMonitorColState = colState
														} catch(e) { console.log(e); return; }
														 }
													},
													// {
													// 	name: 'Load Column Layout..',
													// 	action: function () {
													// 		//Load Column Layout
													// 		try{
													// 			var colState = localStorage.PositionMonitorColState
													//
													// 			console.log("colState: ", colState)
													// 			params.columnApi.setColumnState(JSON.parse(colState))
													// 	} catch(e) { console.log(e); return; }
													// 	 }
													// },

														]
												if (params.node && params.node.data && params.node.data.position_key) {
													let pos = params.node.data
													result.unshift({ name: `[key:${pos.position_key}] RIC:${pos.symbol} Qty:${pos.current_quantity}`,disabled:true})
													result.push('separator')
													result.push({
														name: `Populate ${pos.product_type} Ticket for ${pos.symbol}...`,
														action: function () { raiseWidget(pos.product_type, {symbol: pos.symbol, quantity: Math.abs(pos.current_quantity), book: pos.book_name, tag: pos.tag}) },
													})
													result.push({
														name: `Position Detail for ${pos.symbol}...`,
														action: function () { raiseWidget('PositionDetail', {description:pos.instrument_description ,unit_cost:pos.current_unit_cost , symbol: pos.symbol,position_key:pos.position_key , quantity: pos.current_quantity, book: pos.book_name, tag: pos.tag}) },
													})
												}

											return result
										},
	                }}

	                columnDefs={GRID_COLUMNS}
									rowSelection="single"
									enableSorting="true"
									enableFilter="true"
									toolPanelSuppressRowGroups="true"
									toolPanelSuppressPivotMode="true"
									toolPanelSuppressPivots="true"
									rowHeight="32"
									//
									// onDisplayedColumnsChanged={ (event) => {
                  //     //  if (event.node.selected !== true) return
									// 			// printState()
                  //       console.log("columnChanged => ", event)
									//
									//
									// 		}}
									onRowSelected={ (event) => {
                        if (event.node.selected !== true) return
                        console.log("selected => ", event.node.data)
											}}
									onCellClicked={ (event) => {
										if (event.data && event.colDef.cellDrillDown && !(event.node.group)) {
                      let popoverOpts = {
												placement: 'vertical',
												// container: document.body,
												content: event.colDef.cellDrillDown,
												width: 500, height: 280,
												cache: false,
												backdrop: true,
												trigger: 'manual',
												onHide: function($element) { $($element).remove() },
											}
                      if (event.colDef.cellDrillDownUrl) {
                        Object.assign(popoverOpts, {
                          type: 'async',
                          url: event.colDef.cellDrillDownUrl(event.data),
                          async: {
                            before: function(that, xhr) {
                              xhr.setRequestHeader('Authorization', (window.user ? window.user.token : localStorage.token))
                            }
                          }
                        })
                      } else {
												popoverOpts.content = event.colDef.cellDrillDown(event.data)
											}
											$(event.event.target).webuiPopover(popoverOpts)
											$(event.event.target).webuiPopover('show')
											$('.webui-popover-backdrop').click( () => {
												$(event.event.target).webuiPopover('hide')
											})
										}
									}}
									onViewportChanged={  (event) => {
										if (! this.positionGrid) return
										//  event = {firstRow: 15, lastRow: 42}
										let rowModel = this.positionGrid.rowModel
										let shouldListenPositions = []
										for (var i = event.firstRow; i <= event.lastRow; i++) {
											let row = rowModel.getRow(i)
											if (row.data.position_key) {
										   shouldListenPositions.push(+ row.data.position_key)
											}
										}

										if (! this._listeningPositions) this._listeningPositions = []
										let unsub = _.difference(this._listeningPositions, shouldListenPositions)

										if (unsub.length > 0) {
											for (var i = 0; i < unsub.length; i++) {
												this._position_socket.unsubscribe("pl.Position." + unsub[i])
											}
										}
										if (shouldListenPositions.length > 0) {
											for (var i = 0; i < shouldListenPositions.length; i++) {
												this._position_socket.subscribe("pl.Position." + shouldListenPositions[i])
											}
										}

										this._listeningPositions = shouldListenPositions

									}}

								/>
              </div>
              { this.state.loaded ? undefined : <div className="loader"></div> }
          </div>
      </div>)
	}
}



// WEBPACK FOOTER //
// ./src/pos_monitor.jsx